import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import './UserList.css';

const UserList = observer(({ adminStore }) => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [profileForm, setProfileForm] = useState({
    username: '',
    email: '',
    firstName: '',
    lastName: '',
    password: ''
  });
  const [roleSelection, setRoleSelection] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [localError, setLocalError] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    adminStore.fetchUsers();
    adminStore.fetchRolesAndPermissions(); // чтобы список ролей был доступен
  }, []);

  useEffect(() => {
    if (selectedUser) {
      setProfileForm({
        username: selectedUser.username || '',
        email: selectedUser.email || '',
        firstName: selectedUser.firstName || '',
        lastName: selectedUser.lastName || '',
        password: ''
      });
      setRoleSelection(selectedUser.role ? selectedUser.role.id : '');
    } else {
      setProfileForm({
        username: '',
        email: '',
        firstName: '',
        lastName: '',
        password: ''
      });
      setRoleSelection('');
    }
    setNewPassword('');
  }, [selectedUser]);

  const handleSave = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    setLocalError(null);

    try {
      const userData = {
        username: profileForm.username,
        email: profileForm.email,
        firstName: profileForm.firstName,
        lastName: profileForm.lastName,
        roleId: roleSelection || null
      };

      if (selectedUser) {
        await adminStore.updateUser(selectedUser.id, userData);
      } else {
        userData.password = profileForm.password || '123456';
        await adminStore.createUser(userData);
      }

      await adminStore.fetchUsers();
      setSelectedUser(null);
    } catch (err) {
      setLocalError(err.message || 'Ошибка при сохранении');
    } finally {
      setIsSaving(false);
    }
  };

  const handleAssignRole = async () => {
    if (!selectedUser) return;
  
    setIsSaving(true);
    setLocalError(null);
  
    try {
      // Определяем новый ID роли или null для её удаления
      const newRoleId = roleSelection ? Number(roleSelection) : null;
  
      // Вызываем универсальный метод
      await adminStore.setUserRole(selectedUser.id, newRoleId);
  
      // Обновляем список пользователей и выбранного
      await adminStore.fetchUsers();
      const updated = adminStore.users.find(u => u.id === selectedUser.id);
      setSelectedUser(updated);
  
      // Показываем уведомление
      if (newRoleId !== null) {
        alert('Роль успешно назначена');
      } else {
        alert('Роль успешно удалена');
      }
    } catch (err) {
      setLocalError(err.message || 'Ошибка при обновлении роли');
    } finally {
      setIsSaving(false);
    }
  };
  

  const handleDeleteUser = async (userId) => {
    if (!window.confirm('Вы уверены, что хотите удалить пользователя?')) return;
    try {
      await adminStore.deleteUser(userId);
      await adminStore.fetchUsers();
      setSelectedUser(null);
    } catch (err) {
      setLocalError(err.message || 'Ошибка при удалении пользователя');
    }
  };

  const handleChangePassword = async () => {
    if (!selectedUser || !newPassword) return;
    setIsSaving(true);
    try {
      await adminStore.changeUserPassword(selectedUser.id, newPassword);
      alert('Пароль изменён');
      setNewPassword('');
    } catch (err) {
      alert(err.message || 'Ошибка при смене пароля');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="users-control-container">
      <h1>Управление пользователями</h1>
      {localError && <div className="users-control-error">{localError}</div>}
      <div className="users-control-wrapper">
        <aside className="users-control-sidebar">
          <h2>Пользователи</h2>
          <button onClick={() => setSelectedUser(null)} className="users-control-create-btn">
             Новый пользователь
          </button>
          {adminStore.loadingUsers ? (
            <p>Загрузка...</p>
          ) : (
            <ul className="users-control-list">
              {adminStore.users
                .filter(user => !!user) // ← фильтруем undefined/null
                .map(user => (
                  <li
                    key={user.id}
                    className={`users-control-item ${selectedUser && selectedUser.id === user.id ? 'active' : ''}`}
                    onClick={() => setSelectedUser(user)}
                  >
                    {user.username}
                  </li>
              ))}

            </ul>
          )}
        </aside>

        <main className="users-control-profile">
          <form onSubmit={handleSave} className="users-control-profile-form">
            <h2>{selectedUser ? 'Редактировать' : 'Создать пользователя'}</h2>

            <div className="users-control-group">
              <label>Имя пользователя:</label>
              <input
                type="text"
                value={profileForm.username}
                onChange={(e) => setProfileForm({ ...profileForm, username: e.target.value })}
              />
            </div>
            <div className="users-control-group">
              <label>Email:</label>
              <input
                type="email"
                value={profileForm.email}
                onChange={(e) => setProfileForm({ ...profileForm, email: e.target.value })}
              />
            </div>
            <div className="users-control-group">
              <label>Имя:</label>
              <input
                type="text"
                value={profileForm.firstName}
                onChange={(e) => setProfileForm({ ...profileForm, firstName: e.target.value })}
              />
            </div>
            <div className="users-control-group">
              <label>Фамилия:</label>
              <input
                type="text"
                value={profileForm.lastName}
                onChange={(e) => setProfileForm({ ...profileForm, lastName: e.target.value })}
              />
            </div>

            {!selectedUser && (
              <div className="users-control-group">
                <label>Пароль:</label>
                <input
                  type="password"
                  value={profileForm.password}
                  onChange={(e) => setProfileForm({ ...profileForm, password: e.target.value })}
                />
              </div>
            )}

            <button type="submit" disabled={isSaving}>
              {isSaving ? 'Сохранение...' : selectedUser ? 'Сохранить изменения' : 'Создать'}
            </button>
          </form>
        </main>

        <aside className="users-control-role">
          {selectedUser ? (
            <>
              <h2>Роль и пароль</h2>
              <p>Текущая роль: {selectedUser.role ? selectedUser.role.name : 'Нет роли'}</p>
              <div className="users-control-group">
                <label>Выбрать роль:</label>
                <select
                  value={roleSelection}
                  onChange={(e) => setRoleSelection(e.target.value)}
                >
                  <option value="">Без роли</option>
                  {adminStore.roles.map(role => (
                    <option key={role.id} value={role.id}>
                      {role.name}
                    </option>
                  ))}
                </select>
              </div>
                            <button onClick={handleAssignRole} disabled={isSaving}>
                {isSaving
                  ? (roleSelection ? 'Назначение...' : 'Снятие...')
                  : (roleSelection ? 'Применить роль' : 'Снять роль')
                }
              </button>

              <hr />
              <div className="users-control-group">
                <label>Новый пароль:</label>
                <input
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
                <button onClick={handleChangePassword} disabled={!newPassword || isSaving}>
                  Сменить пароль
                </button>
              </div>

              <hr />
              <button className="users-control-delete-btn" onClick={() => handleDeleteUser(selectedUser.id)}>
                Удалить пользователя
              </button>
            </>
          ) : (
            <p>Выберите пользователя</p>
          )}
        </aside>
      </div>
    </div>
  );
});

export default UserList;
